import { useAlertsQuery } from "./useAlertsQuery";
import { isAlerted } from "@/components/Insights/utils";

export const useAlertCounts = () => {
  const { alerts } = useAlertsQuery();

  const alertedCount = alerts.filter(isAlerted).length;

  return {
    alertedCount,
  };
};
